import {isEmpty} from 'lodash';
import {Http} from '@angular/http';
import {Injectable} from '@angular/core';
import {Observable} from 'rxjs/Observable';
import { Product } from '../product.i';

export const OTHER_PRODUCT = {id: 9, name: "Other", specify: true};

@Injectable()
export class ProductsService {
    constructor(private http: Http) {
    }

    private products: Product[];
    private allProducts: Product[];

    getAllProducts():  Observable<Product[]> {
        if(isEmpty(this.allProducts)){
            return this.http.get('/api/client/dictionary/products?all')
                .map(response => response.json())
                .map(responce =>{
                    this.allProducts = responce.products;
                    return this.allProducts;
                });
        } else {
            return Observable.of(this.allProducts);
        }
    }

    getPrivateProducts(): Observable<Product[]> {
        if (isEmpty(this.products)) {
            return this.http.get('/api/client/dictionary/products/private')
                .map(response => response.json())
                .map(response => {
                    this.products = response.products;
                    return this.products;
                });
        } else {
            return Observable.of(this.products);
        }
    }

    getCorporateProducts(): Observable<Product[]> {
        if (isEmpty(this.products)) {
            return this.http.get('/api/client/dictionary/products/corporate')
                .map(response => response.json())
                .map(response => {
                    this.products = response.products;
                    return this.products;
                });
        } else {
            return Observable.of(this.products);
        }
    }
}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/angular-router-loader/src!./src/common/api/dictionaries/products.service.ts